module.exports = __webpack_public_path__ + "static/img/13.8bb0540.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/13.jpg
// module id = yBT+
// module chunks = 1